import { Dispatch, ReactNode, SetStateAction } from 'react';

import ToggleAddSearchResult from '../ToggleAddSearchResults/ToggleAddSearchResult';

import styles from './SearchPanel.module.css';

type SearchPanelProps = {
  children: ReactNode | ReactNode[];
  add?: boolean;
  setAdd?: Dispatch<SetStateAction<boolean>> | ((checked: boolean) => void);
};
const SearchPanel = ({ children, add = undefined, setAdd = undefined }: SearchPanelProps) => {
  return (
    <div className={styles.searchPanel}>
      {children}
      {add !== undefined && setAdd && (
        <div>
          <ToggleAddSearchResult addSearchResults={add} setAddSearchResults={setAdd} />
        </div>
      )}
    </div>
  );
};
export default SearchPanel;
